import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.min.js";

import React, {useState} from "react";
import ModalImage from "./ModalImage";
import './Album.css';

function Album() {
  const [modalTitle, setModalTitle] = useState();
  const [imgSrc, setImgSrc] = useState();
  const [imgAlt, setImgAlt] = useState();
  const [imgWidth, setImgWidth] = useState();

  const onClickHandler = (modalTitle, imgSrc, imgAlt, imgWidth) => {
    setModalTitle(modalTitle);
    setImgSrc(imgSrc);
    setImgAlt(imgAlt);
    setImgWidth(imgWidth);
  };

  return (
    <>
      <ModalImage
        modalTitle={modalTitle}
        imgSrc={imgSrc}
        imgAlt={imgAlt}
        imgWidth={imgWidth}
      />
      <div className="container">
        <div className="album py-5 bg-light">
          <div className="container">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
              <div className="col">
                <div className="card shadow-sm">
                  {/*}
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/ancilla-tilia.jpg"
                    alt="Ancilla Tilia"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Ancilla Tilia",
                              "https://www.marchouben.nl/afbeeldingen/ancilla-tilia.jpg",
                              "Ancilla Tilia",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/anneke-van-giersbergen-the-gathering.jpg"
                    alt="Anneke van Giersbergen"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Anneke van Giersbergen",
                              "https://www.marchouben.nl/afbeeldingen/anneke-van-giersbergen-the-gathering.jpg",
                              "Anneke van Giersbergen",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/jlo-green-dress.jpg"
                    alt="Jennifer Lopez"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Jennifer Lopez",
                              "https://www.marchouben.nl/afbeeldingen/jlo-green-dress.jpg",
                              "Jennifer Lopez",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/barbara-carrera.jpg"
                    alt="Barbara Carrera"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Barbara Carrera",
                              "https://www.marchouben.nl/afbeeldingen/barbara-carrera.jpg",
                              "Barbara Carrera",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/maria-sharapova.jpg"
                    alt="Maria Sharapova"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Maria Sharapova",
                              "https://www.marchouben.nl/afbeeldingen/maria-sharapova.jpg",
                              "Maria Sharapova",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/monica-bellucci.jpg"
                    alt="Monica Bellucci"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Monica Bellucci",
                              "https://www.marchouben.nl/afbeeldingen/monica-bellucci.jpg",
                              "Monica Bellucci",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/patricia-kaas.jpg"
                    alt="Patricia Kaas"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Patricia Kaas",
                              "https://www.marchouben.nl/afbeeldingen/patricia-kaas.jpg",
                              "Patricia Kaas",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/mariah-carey-boezem.webp"
                    alt="Mariah Carey"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Mariah Carey",
                              "https://www.marchouben.nl/afbeeldingen/mariah-carey-boezem.webp",
                              "Mariah Carey",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card shadow-sm">
                  {/*
                <svg
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  xmlns="http://www.w3.org/2000/svg"
                  role="img"
                  aria-label="Placeholder: Thumbnail"
                  preserveAspectRatio="xMidYMid slice"
                  focusable="false"
                >
                  <title>Placeholder</title>
                  <rect width="100%" height="100%" fill="#55595c" />
                  <text x="50%" y="50%" fill="#eceeef" dy=".3em">
                    Thumbnail
                  </text>
                </svg>
                */}
                  <img
                    src="https://www.marchouben.nl/afbeeldingen/beyonce-knowles.jpg"
                    alt="Beyonce Knowles"
                  />
                  <div className="card-body">
                    <p className="card-text">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal"
                          onClick={() => {
                            onClickHandler(
                              "Beyonce Knowles",
                              "https://www.marchouben.nl/afbeeldingen/beyonce-knowles.jpg",
                              "Beyonce Knowles",
                              "95%"
                            );
                          }}
                        >
                          View
                        </button>
                        {/*<button
                          type="button"
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Edit
                        </button>*/}
                      </div>
                      {/*<small className="text-muted">9 mins</small>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Album;